module.exports = __webpack_public_path__ + "static/media/home-fc.09c98336.svg";